import TablePagination from '@mui/material/TablePagination';
import { PAGE_SIZE_OPTIONS } from '@/shared/api/page';

type Props = {
  total: number;
  page: number;
  pageSize: number;
  onPageChange: (page: number) => void;
  onPageSizeChange: (size: number) => void;
};

/** The only place the 1-based API page meets MUI's 0-based page. */
export function ListPagination({ total, page, pageSize, onPageChange, onPageSizeChange }: Props) {
  return (
    <TablePagination
      component="div"
      count={total}
      page={total === 0 ? 0 : page - 1}
      rowsPerPage={pageSize}
      rowsPerPageOptions={[...PAGE_SIZE_OPTIONS]}
      onPageChange={(_, p) => { onPageChange(p + 1); }}
      onRowsPerPageChange={(e) => { onPageSizeChange(Number(e.target.value)); }}
    />
  );
}
